<template>
  <header @dblclick.stop="allowCheckRegion = !allowCheckRegion">
    <template v-if="isMobile">
      <div class="left">
        <!-- <div class="menu" @click="openMobileMenu">
          <fps-icon type="menu" size="26" />
        </div> -->
        <div class="logo" @click="openMobileMenu">
          <img src="~@/assets/image/icons/logo.png" alt="" />
          <!-- <fps-icon type="nicee" size="30" /> -->
        </div>
      </div>
      <div class="right">
        <div class="header-button openapp" @click="downloadApp">{{$t('upgrade_page_layout_header_5')}}</div>
        <div
          v-if="!userInfo"
          class="header-button mobilelogin"
          :class="{ disabled: loginLoading }"
          @click="handleLogin"
        >{{$t('upgrade_page_layout_header_6')}}</div>
      </div>
      <el-dialog
        :visible.sync="mobileMenu"
        :modal-append-to-body="false"
        width="100%"
        custom-class="dialog-mobile-menu"
        @close="handleCloseMenu"
      >
        <nav v-if="userInfo">
          <router-link
            class="nav-userinfo"
            :to="`/player-detail/${userInfo.uuid}`"
            replace
          >
            <!-- 移动自适应头像 -->
            <div
              class="avatar-wrap"
              :style="{ marginRight: showLevelFrame ? '12px' : '4px' }"
            >
              <fps-avatar
                :src="userInfo.avatarUrl"
                :level="userInfo.userLevel"
                :dressup="userInfo.avatarFrame"
              />
              <div
                v-if="isPlayer"
                class="online-status"
                :class="{ 'is-online': isOnline }"
              ></div>
            </div>
            <div class="user-name">
              {{ userInfo.nickname }}
            </div>
          </router-link>
        </nav>
        <nav v-else :class="{ disabled: loginLoading }" @click="handleLogin">
          <div class="dialog-login">{{$t('upgrade_page_layout_header_6')}}</div>
        </nav>
        <div class="line"></div>
        <nav>
          <router-link to="/quick-order" replace>
            <fps-icon class="icon" type="quick-order2" size="24" />{{$t('upgrade_page_layout_header_7')}}</router-link>
        </nav>
        <nav @click="loadApp">
          <div><fps-icon class="icon" type="find" size="24" />{{$t('upgrade_page_layout_header_8')}}</div>
        </nav>
        <nav v-if="userInfo && !isPlayer">
          <router-link to="/settled" replace>
            <fps-icon class="icon" type="be-master1" size="24" />{{$t('upgrade_page_layout_header_9')}}</router-link>
        </nav>
        <nav>
          <a @click.prevent="toCustomer()">
            <fps-icon
              class="icon"
              type="customer-service"
              size="22"
              style="margin: 1px 13px 1px 1px;"
            />{{$t('upgrade_page_layout_header_10')}}</a>
        </nav>
        <nav>
          <router-link to="/qa" replace>
            <fps-icon class="icon" type="question2" size="24" />{{$t('upgrade_page_layout_header_11')}}</router-link>
        </nav>
        <!-- <nav>
          <a href="https://www.facebook.com/102768321269306/" target="_blank">
            <fps-icon
              class="icon"
              type="facebook1"
              size="18"
              style="margin: 3px 15px 3px 3px;"
            />FB粉絲團
          </a>
        </nav> -->
        <!-- <nav>
          <a href="https://discord.gg/TUpC4svvQf" target="_blank">
            <fps-icon
              class="icon"
              type="discord1"
              size="18"
              style="margin: 3px 15px 3px 3px;"
            />DC官網
          </a>
        </nav> -->
        <div class="line"></div>
        <div class="dialog-download" @click="downloadApp">
          <p>{{ textDownload }}</p>
          <img
            v-if="$util.nativeType === 'iOS'"
            src="~@/assets/image/icons/download-ios.png"
          />
          <img
            v-if="$util.nativeType === 'android'"
            src="~@/assets/image/icons/download-android.png"
          />
        </div>
        <nav v-if="userInfo">
          <a @click.prevent="handleLogout">
            <fps-icon class="icon" type="sign-out" size="24" />{{$t('upgrade_page_layout_header_12')}}</a>
        </nav>
      </el-dialog>
    </template>
    <template v-else>
      <div class="left">
        <!-- <div v-if="showMenu" class="menu" @click="$emit('switch-toggle')">
          <fps-icon type="menu" size="26" />
        </div> -->
        <div class="logo" @click="$emit('switch-toggle')">
          <img src="~@/assets/image/icons/logo.png" alt="" />
          <!-- <fps-icon type="nicee" size="34" /> -->
        </div>
        <div v-if="isDashboard" class="page-title">{{$t('upgrade_page_layout_header_13')}}</div>
        <div
          v-else
          class="search"
          :class="{ active: searchVal || searchFocus }"
        >
          <input
            ref="search"
            type="text"
            v-model.trim="searchVal"
            :placeholder="$t('upgrade_page_layout_header_14')"
            @focus="searchFocus = true"
            @blur="searchFocus = false"
            @keyup="handleSearch"
            @change="handleSearch()"
          />
          <div class="icon" @click="handleSearch()">
            <fps-icon type="search" size="20" />
          </div>
        </div>
      </div>
      <div class="right">
        <!-- <span class="ip" v-if="ipCityName">當前ip歸屬：{{ ipCityName }}</span> -->
        <!-- <el-select
          v-model="region"
          placeholder="请选择地区"
          @change="selectRegion()"
          v-if="allowCheckRegion"
        >
          <el-option
            v-for="item in regionOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select> -->
        <template v-if="!isDashboard">
          <div
            class="header-button dashboard"
            v-if="
              isVoiceRoomWhiteUser && $route.name != 'AdministratorManagement'
            "
            @click="openAdministratorManagement"
          >{{$t('upgrade_page_layout_header_15')}}</div>
          <!-- <div
            v-if="userInfo && isPlayer"
            class="header-button dashboard"
            @click="openDashboard"
          >
            <fps-icon class="board" type="dashboard" size="16" />陪玩管理中心
          </div> -->
          <div
            class="header-button download"
            v-if="$route.path != '/login' && $route.path != '/app'"
            @click="$router.push('/app')"
          >{{$t('upgrade_page_layout_header_16')}}Nicee
            <!-- <div class="qrcode-box">
              <figure class="qrcode">
                <qrcode
                  :value="appLinkUrl"
                  :options="{
                    margin: 0
                  }"
                >
                </qrcode>
                <img
                  class="qrcode__image"
                  src="~@/assets/image/pics/download-logo.png"
                  alt="Chen Fengyuan"
                />
              </figure>

              <div class="app-icon-box">
                <img
                  class="app-icon"
                  src="~@/assets/image/pics/download-googleplay.png"
                  alt=""
                />
                <img
                  class="app-icon"
                  src="~@/assets/image/pics/download-appstore.png"
                  alt=""
                />
              </div>
            </div> -->

            <!-- <img src="~@/assets/image/pics/download-qr-code.png" /> --></div>
          <!-- 鑽石餘額展示 -->
          <div
            v-if="userInfo && accountInfo"
            class="crystal-balance"
            @click="handleRoute('/diamond-recharge')"
          >
            <img src="~@/assets/image/icons/diamond.png" />
            <span>{{ accountInfo.diamondBalance || 0 }}</span>
            <div class="plus">
              <fps-icon type="add" size="16" />
            </div>
          </div>
          <div
            v-if="redCircleInfo.firstRecharge"
            class="balance"
            @click="handleRoute('/saving')"
          >
            <img src="~@/assets/image/icons/gold-icon.png" />
            <span>{{$t('upgrade_page_layout_header_17')}}</span>
            <sup style="top: -10px; width: 0; left: -14px;"
              ><img
                src="~@/assets/image/icons/badge_first_charge.png"
                style="width: 36px;height: 20px;"
            /></sup>
          </div>

          <div
            v-else-if="userInfo && accountInfo"
            class="balance"
            @click="handleRoute('/saving')"
          >
            <img src="~@/assets/image/icons/gold-icon.png" />
            <span>{{ accountInfo.balance || 0 }}</span>
            <div class="plus">
              <fps-icon type="add" size="16" />
            </div>
          </div>
        </template>
        <template v-if="$route.name !== 'Login'">
          <template v-if="userInfo">
            <!-- <div class="message">
              <fps-icon type="notice1" size="24" />
              <span v-show="unreadNtc">{{ unreadNtc }}</span>
            </div> -->
            <div class="message" @click="toChatPage">
              <fps-icon type="message" size="24" />
              <span v-show="unreadMsg">{{ unreadMsg }}</span>
            </div>
            <!-- header最右侧头像 -->
            <div class="avatar-wrap" @click="clickAvatar">
              <fps-avatar
                :src="userInfo.avatarUrl"
                :dressup="userInfo.avatarFrame"
                :level="userInfo.userLevel"
              />
              <div
                v-if="isPlayer"
                class="online-status"
                :class="{ 'is-online': isOnline }"
              ></div>
              <transition name="fade">
                <div v-show="showUserCard" class="user-info-card" @click.stop>
                  <transition :name="'slide-left'">
                    <div>
                      <div
                        class="handle-box user-info-box"
                        @click="handleRoute(`/player-detail/${userInfo.uuid}`)"
                      >
                        <!-- 下拉菜单头像 -->
                        <div
                          class="avatar-wrap"
                          :style="{
                            marginTop: showLevelFrame ? '-4px' : '0',
                            marginRight: showLevelFrame ? '14px' : '7px'
                          }"
                        >
                          <fps-avatar
                            :src="userInfo.avatarUrl"
                            :dressup="userInfo.avatarFrame"
                          />
                          <div
                            v-if="isPlayer"
                            class="user-status"
                            :class="{ 'is-online': isOnline }"
                          ></div>
                        </div>
                        <div class="user-info">
                          <div class="nickname">
                            <span>{{ userInfo.nickname }}</span>
                          </div>
                          <div
                            class="user-level-wrap"
                            @click.stop="handleRoute('/vip-center')"
                          >
                            <div
                              class="userlevel-tag"
                              v-if="userInfo.userLevel"
                              :class="`level-${userInfo.userLevel}`"
                            ></div>
                            <span
                              class="user-level-text"
                              :style="{
                                color: getUserlevelColor(userInfo.userLevel)
                              }"
                              >{{ userInfo.userLevel | getUserlevel }}</span
                            >
                            <i class="user-level-arrow el-icon-arrow-right"></i>
                          </div>
                        </div>
                      </div>
                      <template v-if="isDashboard">
                        <div class="split"></div>
                        <div class="handle-box" @click="handleRoute('/')">
                          <img
                            class="handle-image"
                            src="~@/assets/image/icons/logo.png"
                          />
                          <div class="title">{{$t('upgrade_page_layout_header_18')}}</div>
                        </div>
                      </template>
                      <template v-else>
                        <div v-if="isPlayer" class="user-positive">
                          <div class="title">
                            <p @click="showIntroPositive">{{$t('upgrade_page_layout_header_19')}}</p>
                          </div>
                          <fps-switch
                            class="switch"
                            :value="isOnline"
                            :loading="statusLoading"
                            @change="changeStatus"
                          />
                        </div>
                        <div class="split"></div>
                        <div
                          class="handle-box"
                          @click="openDashboard()"
                          v-if="userInfo && isPlayer"
                        >
                          <fps-icon type="dashboard" size="20" />
                          <div class="title">{{$t('upgrade_page_layout_header_13')}}</div>
                        </div>
                        <div
                          class="handle-box"
                          @click="handleRoute('/order-list')"
                        >
                          <fps-icon type="order" size="20" />
                          <div class="title">{{$t('upgrade_page_layout_header_20')}}</div>
                        </div>
                        <div
                          class="handle-box"
                          @click="handleRoute('/wallet-info')"
                        >
                          <fps-icon type="wallet" size="20" />
                          <div class="title">{{$t('upgrade_page_layout_header_21')}}</div>
                        </div>
                        <div class="handle-box" @click="handleCoupons">
                          <fps-icon type="coupon" size="20" />
                          <div class="title">{{$t('upgrade_page_layout_header_22')}}</div>
                          <div
                            v-if="redCircleInfo.coupons"
                            class="red-circle"
                          />
                        </div>
                      </template>
                      <div class="split"></div>
                      <!-- <div class="handle-box" @click="handleRoute(`/user-info`)">
                        <fps-icon type="account" size="20" />
                        <div class="title">個人資料編輯</div>
                      </div> -->
                      <div
                        class="handle-box"
                        v-if="
                          (!userInfo || !isPlayer) && $route.path != '/login'
                        "
                        @click="handleRoute('/before-settled')"
                      >
                        <fps-icon type="be-master1" size="20" />
                        <div class="title">{{$t('upgrade_page_layout_header_23')}}</div>
                      </div>
                      <div
                        class="handle-box"
                        @click="handleRoute('/user-info')"
                      >
                        <fps-icon type="edit" size="20" color="#222C43" />
                        <div class="title">{{$t('upgrade_page_layout_header_24')}}</div>
                      </div>
                      <div class="handle-box" @click="handleRoute('/user-set')">
                        <fps-icon type="setting" size="20" />
                        <div class="title">{{$t('upgrade_page_layout_header_25')}}</div>
                      </div>
                      <div class="handle-box" @click="openLine()">
                        <img
                          class="icon-line"
                          src="~@/assets/image/icons/line.png"
                          alt=""
                        />
                        <div class="title">{{$t('upgrade_page_layout_header_26')}}</div>
                      </div>
                      <div class="handle-box" @click="openInstagram()">
                        <img
                          class="icon-instagram"
                          src="~@/assets/image/icons/icon-instagram.png"
                          alt=""
                        />
                        <div class="title">{{$t('upgrade_page_layout_header_27')}}</div>
                      </div>
                      <div class="handle-box" @click="toCustomer()">
                        <fps-icon type="customer-service" size="20" />
                        <div class="title">{{$t('upgrade_page_layout_header_10')}}</div>
                      </div>
                      <div class="handle-box" @click="handleLogout">
                        <fps-icon type="sign-out" size="20" />
                        <div class="title">{{$t('upgrade_page_layout_header_12')}}</div>
                      </div>
                    </div>
                  </transition>
                </div>
              </transition>
            </div>
          </template>
          <div
            v-else
            class="header-button login"
            :class="{ disabled: loginLoading }"
            @click="handleLogin"
          >{{$t('upgrade_page_layout_header_32')}}</div>
        </template>
      </div>
      <DialogPositive v-model="introPositive" />
    </template>
  </header>
</template>

<script>
import i18n from '../../locales/index'
import IM from '@/plugins/im';
import { mapGetters } from 'vuex';
import DialogPositive from './dialog-positive';
import { clearRedCircle } from '@/api';
import { getUserlevelColor } from '@/filters';
// import VueQrcode from '@chenfengyuan/vue-qrcode';
import NewerREdBag from '@/components/Login/components/newer-redbag';
import AmountCoponent from '@/components/common/amount/global-amount.jsx';
const DisplayNewerRedbag = AmountCoponent(NewerREdBag);

// Vue.component(VueQrcode.name, VueQrcode);
export default {
  components: {
    DialogPositive
    // qrcode: VueQrcode
  },
  data() {
    return {
      isLocal: !!window.location.port,
      searchVal: '',
      searchFocus: false,
      showUserCard: false,
      loginLoading: false,
      statusLoading: false, // 切換積極接單
      introPositive: false,
      isMobile: window.innerWidth < 600,
      mobileMenu: this.$util.getUrlParam('mobilemenu') == '1',
      appLinkUrl:
        process.env.VUE_APP_ENV == 'test'
          ? 'https://test.nicee.tw/download-app'
          : 'https://nicee.tw/download-app',
      isPayDialog: false,
      voiceRoomWhiteList: [],
      region: localStorage.getItem('REGION') || 'US',
      allowCheckRegion: false
      // 用户等级颜色
      // myVoiceRooms:[]
      // ipCityName: '' // ip地址
    };
  },
  props: {
    // 搜索接口請求過程中
    searching: {
      type: Boolean,
      default: false
    },
    // 隱藏菜單按鈕（隱藏左側導航）
    showMenu: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'accountInfo',
      'imUnreadMessageCount',
      'redCircleInfo'
    ]),
    uuid() {
      return this.userInfo ? this.userInfo.uuid : '';
    },
    // 頁面path
    $routePath() {
      return this.$route.fullPath;
    },
    // 首页
    isHomePage() {
      return this.$route.name === 'homepage';
    },
    // B端用户
    isPlayer() {
      return this.userInfo && this.userInfo.userKind === 'Player';
    },
    // 是仪表板页面
    isDashboard() {
      return this.isPlayer && this.$route.path.indexOf('/player/') === 0;
    },
    // 積極接單
    isOnline() {
      return this.userInfo && this.userInfo.wantOrder;
    },
    // 在线时间
    onlineTime() {
      return this.$util.onlineTime(this.userInfo);
    },
    // 未读的系统通知（信令），暂时不做
    unreadNtc() {
      return 1;
    },
    // 未读的 IM 消息
    unreadMsg() {
      const num = this.imUnreadMessageCount;
      return num > 99 ? '99+' : num > 0 ? num : '';
    },
    // 下载引导文案
    textDownload() {
      return this.isPlayer
        ? i18n.t('upgrade_page_layout_header_46')
        : i18n.t('upgrade_page_layout_header_37');
    },
    // 显示等级头像框
    showLevelFrame() {
      return this.userInfo && this.userInfo.userLevel > 5;
    },
    isVoiceRoomWhiteUser() {
      const isProduction = process.env.VUE_APP_ENV === 'production';
      if (isProduction) {
        // return [
        //   //陪玩师名单
        //   '2266452', //鹿玖
        //   // '157263'//熊兒
        //   '4292676',
        //   '4285891',
        //   '4328101',
        //   '3783920', //邹滨
        //   '3762573', // 雷敏
        //   '4310601',
        //   '4323727',
        //   '4286608',
        //   '4347257',
        //   '4329482',
        //   '4290568', //卫腾
        //   '3826053'
        // ]
        return this.voiceRoomWhiteList.includes(this.uuid);
      } else {
        return true;
      }
    }
  },
  watch: {

    $routePath() {
      this.mobileMenu = this.$util.getUrlParam('mobilemenu') == '1';
    },
    uuid: {
      handler: function(val) {
        if (val) {
          this.getWhiteList();
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    getUserlevelColor,
    async getWhiteList() {
      try {
        const { data } = await this.$http.get(
          '/player/skill/userWhite/list/32'
        );
        this.voiceRoomWhiteList = data || [];
      } catch (error) {
        console.log(error);
      }
    },
    handleCoupons() {
      this.redCircleInfo.coupons &&
        clearRedCircle({
          field: 'coupons'
        }).then(() => {
          this.$store.dispatch('app/setRedCircle', { coupons: false });
        });
      this.handleRoute('/coupons');
    },
    loadApp() {
      window.loadApp({
        content: i18n.t('upgrade_page_layout_header_38')
      });
    },
    clickSearch() {
      this.$emit('search-toggle', true);
      this.$nextTick(() => {
        const $search = this.$refs['search'];
        $search.select();
      });
    },
    handleSearch(event) {
      if (!this.searchVal || this.searching) return;
      if (!event || event.keyCode === 13) {
        // change 事件/ 點擊按鈕/ 按下回车
        const keyword = encodeURIComponent(this.searchVal);
        // 容错处理
        if (!keyword || keyword === ' ') {
          this.$emit('search-toggle', false);
          return;
        }
        const path = `/search-list/${encodeURIComponent(
          this.searchVal
        )}?t=${Date.now()}`;
        if (this.$route.name === 'searchList') {
          // 在搜索頁進行搜索
          this.$router.replace({ path });
        } else {
          // 在其他頁面搜索
          this.$router.push({ path });
        }
      }
    },
    clickAvatar() {
      if (this.showUserCard) return;
      this.showUserCard = true;
      setTimeout(() => {
        document.addEventListener('click', this.hideUserCard);
      }, 100);
    },
    hideUserCard() {
      this.showUserCard = false;
      document.removeEventListener('click', this.hideUserCard);
    },
    // 切换積極接單状态
    changeStatus() {
      if (this.statusLoading) return;
      this.statusLoading = true;
      this.$http
        .post('/user/save/onlineStatus', {
          userOnlineStatus: this.isOnline ? 'Offline' : 'Online'
        })
        .then(async () => {
          await this.$store.dispatch('app/getUserInfo');
          this.statusLoading = false;
        })
        .catch(err => {
          if (err.code === 652 || err.msg.includes('STILL_BANNED')) {
            this.$message.error(
              i18n.t('upgrade_page_layout_header_39')
            );
          }
          this.statusLoading = false;
        });
    },
    // 顯示積極接單介紹彈窗
    showIntroPositive() {
      this.introPositive = true;
      this.showUserCard = false;
    },
    handleLogin() {
      if (this.loginLoading) return;
      this.$util
        .Login({ isHome: this.isHomePage, redirect: this.$route.path })
        .then(async params => {
          await this.$store.dispatch('app/getUserAccount');
          // if (this.$route.path !== '/') {
          //   this.$router.go(-1);
          // }
          // location.reload()
          if (params) {
            const { redirect } = params;
            if (redirect && this.$route.path != redirect) {
              this.$router.replace({ path: redirect });
            }
          }
          if (this.$route.path === '/login') {
            this.$router.replace({ path: '/' });
          }
          console.log(this.userInfo);
          if (this.userInfo.isNewRegistration && this.userInfo.hasRedBag) {
            DisplayNewerRedbag();
          }
        });
    },
    handleLogout() {
      this.$confirm({
        content: i18n.t('upgrade_page_layout_header_40'),
        confirmButtonText: i18n.t('upgrade_page_layout_header_41'),
        cancelButtonText: i18n.t('upgrade_page_layout_header_42')
      }).then(async () => {
        if (this.isMobile) {
          this.$router.go(-1);
        } else {
          IM.imSdkLogout();
          this.$store.dispatch('im/updateUnreadCount', 0);
          this.$store.dispatch('im/selectConversation', null);
        }
        await this.$store.dispatch('app/resetToken');
        if (this.$route.meta && this.$route.meta.needLogin) {
          this.$router.replace({
            path: '/login',
            query: {
              redirect: encodeURIComponent(this.$routePath)
            }
          });
        }
      });
    },
    toHomePage() {
      if (this.isHomePage) {
        this.$router.go(0);
        return;
      }
      // if (this.isDashboard) {
      //   this.$router.push({ path: '/player/dashboard' })
      //   return
      // }
      this.$router.push({ path: '/' });
    },
    toChatPage() {
      this.$util.openChatWindow(this.userInfo.uuid);
    },
    handleRoute(path = '/user-center') {
      if (this.$route.path === path) {
        this.$router.go(0);
        return;
      }
      this.hideUserCard();
      this.$router.push({ path });
    },
    imInit() {
      IM.imSdkInit();
    },
    switchLanguage(target) {
      if (target == 'tw') {
        location.href = 'https://www.nicee.tw/';
      } else if (target == 'jp') {
        location.href = 'https://www.nicee.jp/';
      } else if (target == 'us') {
        location.href = 'https://www.nice-e.com/';
      }
    },
    openDashboard() {
      this.$util.openDashboardWindow();
    },
    openMobileMenu() {
      const path = this.$routePath;
      this.$router.push(
        `${path}${path.indexOf('?') === -1 ? '?' : '&'}mobilemenu=1`
      );
    },
    handleCloseMenu() {
      if (this.$util.getUrlParam('mobilemenu') && window.history.length > 1) {
        this.$router.go(-1);
      }
    },
    // web移动菜单
    downloadApp() {
      this.$util.jumpAppStore();
    },
    downloadAppConfirm() {
      window.loadApp({
        content: i18n.t('upgrade_page_layout_header_43'),
        confirmButtonText: i18n.t('upgrade_page_layout_header_44'),
        cancelButtonText: i18n.t('upgrade_page_layout_header_45'),
        closeOnClickModal: false,
        closeOnPressEscape: false
      });
    },
    openAdministratorManagement() {
      window.open('/administrator-management');
    },
    async selectRegion() {
      localStorage.setItem('REGION', this.region);
      this.$store.dispatch('app/setRegion', {
        region: this.region
      });
      await this.$store.dispatch('app/resetToken');
      location.reload();
    },
    // getMyVoiceRoomList() {
    //   return this.$http.get('/voiceRoom/outside/myRoom').then(({ data }) => {
    //     this.myVoiceRooms = data;
    //   });
    // }
    openLine() {
      window.open('https://line.me/ti/p/hT2U1C1Qn6', '_blank');
    },
    openInstagram() {
      window.open(
        'https://www.instagram.com/nicee.app?igsh=cWppNnYyNTFwcWRn&utm_source=qr',
        '_blank'
      );
    },
    toCustomer() {
      if (this.userInfo) {
        this.$util.openChatWindow(this.userInfo.uuid, '250226');
      } else {
        this.$util.Login();
      }
    }
  },
  mounted() {
    // this.getMyVoiceRoomList();
  },
  created() {
    // this.$http.get('/user/getAddres').then(data => {
    //   try {
    //     if (data.data) {
    //       const ipDto = JSON.parse(data.data);
    //       // this.ipCityName = ipDto.pro + ipDto.city;
    //       if (ipDto.pro === '台湾省' || ipDto.pro === '台灣省') {
    //         this.ipCityName = '台灣';
    //       } else {
    //         this.ipCityName = ipDto.pro;
    //       }
    //     }
    //     console.log('ipData', data, JSON.parse(data.data));
    //   } catch (error) {
    //     console.log(error);
    //   }
    // });
  }
};
</script>

<style lang="scss" scoped>
.avatar-wrap {
  position: relative;
  z-index: 0;

  .online-status {
    position: absolute;
    right: 4px;
    bottom: 4px;
    width: 10px;
    height: 10px;
    border: 2px solid #fff;
    border-radius: 100%;
    background: $color-offline;

    &.is-online {
      background: $color-green;
      z-index: 1;
    }
  }
}

header {
  position: relative;
  flex-shrink: 0;
  @include flex(space-between);
  width: 100%;
  height: 66px;
  padding: 0 24px;
  z-index: 1;
  background: #fff;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);

  .left {
    @include flex;
  }

  .right {
    .ip {
      display: inline-block;
      font-size: 14px;
      // width: 130px;
      white-space: nowrap;
      color: #222c43;
    }
    @include flex(flex-end);

    & > * {
      position: relative;
      cursor: pointer;
      margin-left: 16px;
    }
  }

  .header-button {
    @include flex;
    padding: 0 20px;
    height: 32px;
    color: $color-gray-1;
    font-size: 14px;
    font-weight: 500;
    border-radius: 20px;
    white-space: nowrap;

    &:hover {
      background: $color-button;
    }
  }

  .menu,
  .message,
  .avatar-wrap {
    @include flex;
    position: relative;
    width: 40px;
    height: 40px;
    border-radius: 40px;
    color: $color-gray-1;
    cursor: pointer;

    &:hover {
      background-color: $color-button;
    }
  }

  .menu {
    margin: 0 8px 0 0;
  }

  // header最右侧头像
  .avatar-wrap {
    width: 44px;
    height: 44px;
    padding: 6px;
  }

  .logo {
    flex-shrink: 0;
    @include flex;
    width: auto;
    height: 34px;
    color: $color-gray-1;
    cursor: pointer;
    padding-left: 10px;

    img {
      width: auto;
      height: 24px;
      margin-right: 4px;
    }
  }

  .page-title {
    margin-left: 4px;
    color: $color-gray-3;
    font-size: 16px;
    font-weight: bold;
  }

  .search {
    @include flex;
    margin-left: 96px;
    width: 240px;
    height: 32px;
    color: $color-split;
    background: rgba(232, 234, 238, 0.4);
    border: 1px solid rgba(140, 148, 170, 0.1);
    border-radius: 32px;

    input {
      flex-grow: 1;
      margin-left: 16px;
      line-height: 14px;
      color: $color-gray-1;
      font-size: 14px;
      padding: 8px 0;

      &::placeholder {
        line-height: 14px;
        color: $color-gray-3;
        font-size: 14px;
        font-weight: 300;
        opacity: 0.5;
      }
    }

    .icon {
      flex-shrink: 0;
      margin-right: 12px;
      width: 32px;
      height: 32px;
      padding: 6px;
      color: #d6d9e1;
      cursor: pointer;
    }

    &:focus,
    &.active {
      border: 1px solid rgba(140, 148, 170, 0.4);

      .icon {
        color: $color-gray-1;
      }
    }
  }

  .balance,
  .crystal-balance {
    @include flex;
    height: 32px;
    padding: 4px;
    border-radius: 32px;
    background-color: $color-button;

    &:hover {
      background-color: $color-split;
    }

    img,
    .plus {
      width: 24px;
      height: 24px;
    }

    span {
      margin: 0 12px;
      color: $color-gray-1;
      font-size: 14px;
      font-weight: 600;
    }

    .plus {
      @include flex;
      background-color: $color-gray-2;
      border-radius: 100%;
      color: #fff;
    }
  }

  .message {
    padding: 8px;

    span {
      height: 20px;
      line-height: 16px;
      position: absolute;
      z-index: 1;
      left: 50%;
      top: 0;
      background: $color-red;
      border: 2px solid #fff;
      border-radius: 20px;
      padding: 0 5px;
      color: #fff;
      font-size: 11px;
      font-weight: 500;
    }
  }

  .login {
    padding: 0 27px 0 29px;
    @include button-yellow;
  }

  .dashboard {
    border: 2px solid rgba(34, 44, 67, 0.8);

    .board {
      margin-right: 3px;
    }
  }

  .download {
    margin: 0 16px 0 8px;
    position: relative;
    display: flex;
    flex-direction: column;

    .nicee {
      margin-left: 3px;
    }

    // .qrcode-box {
    //   position: absolute;
    //   left: 50%;
    //   top: 100%;
    //   transform: translate(-50%, 0);
    //   // width: auto;
    //   // height: 200px;
    //   display: none;
    //   background-color: white;
    //   padding: 10px;
    //   border-radius: 4px;

    //   .qrcode {
    //     display: inline-block;
    //     font-size: 0;
    //     margin-bottom: 0;
    //     position: relative;
    //   }

    //   .qrcode__image {
    //     // border: 0.25rem solid #fff;
    //     // border-radius: 50%;
    //     // box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.25);
    //     // height: 15%;
    //     background: white;
    //     border-radius: 50%;
    //     padding: 4px;
    //     width: 30px;
    //     box-sizing: border-box;
    //     left: 50%;
    //     overflow: hidden;
    //     position: absolute;
    //     top: 50%;
    //     transform: translate(-50%, -50%);
    //     // width: 15%;
    //     // z-index: 2;
    //   }

    //   .app-icon-box {
    //     display: flex;
    //     align-items: center;
    //     justify-content: space-between;
    //     margin-top: 10px;
    //   }

    //   .app-icon {
    //     width: 60px;
    //   }
    // }

    // img {
    //   position: absolute;
    //   left: 50%;
    //   top: 100%;
    //   transform: translate(-50%, 7px);
    //   width: auto;
    //   height: 200px;
    //   display: none;
    // }
    // &:hover {
    //   img {
    //     display: block;
    //   }
    // }
    // &:hover {
    //   .qrcode-box {
    //     display: block;
    //   }
    // }
  }

  .im-switch {
    padding: 0 10px 0 12px;
    color: #fff;
    font-size: 12px;
    background: $color-orange;
  }

  .user-info-card {
    @include flex(flex-start, flex-start);
    flex-wrap: nowrap;
    position: absolute;
    overflow: hidden;
    z-index: 99;
    right: 0;
    top: 100%;
    transform: translate(8px, 8px);
    width: 220px;
    background: #fff;
    border: 1px solid $color-split;
    border-radius: 8px;
    box-shadow: 1px 2px 10px rgba(0, 0, 0, 0.08);
    cursor: default;

    > div {
      flex-shrink: 0;
      overflow: hidden;
      padding: 8px;
      width: 100%;
    }

    .handle-box {
      @include flex(flex-start);
      min-height: 36px;
      padding: 0 8px;
      color: $color-gray-1;
      font-size: 14px;
      cursor: pointer;
      position: relative;

      .red-circle {
        position: absolute;
        top: 6px;
        left: 20px;
        border-radius: 50%;
        border: 1px solid #fff;
        background: $color-red;
        width: 10px;
        height: 10px;
      }

      .handle-image {
        width: 20px;
      }

      & + .handle-box {
        margin-top: 4px;
      }

      &.user-info-box {
        padding: 6px 8px 6px 9px;
      }

      &:hover {
        background: $color-split;
        border-radius: 6px;
      }

      .title {
        flex-grow: 1;
        margin: 0 10px;
      }

      .arrow {
        color: $color-gray-3;
      }
    }

    // 下拉菜单中的头像
    .avatar-wrap {
      flex-shrink: 0;
      width: 38px;
      height: 38px;
      padding: 0;
    }

    .user-info {
      flex-grow: 1;
      overflow: hidden;

      .nickname {
        @include flex(flex-start);
        overflow: hidden;
        height: 20px;
        line-height: 20px;
        color: $color-gray-1;
        font-size: 14px;
        font-weight: 500;

        span {
          @include ellipsis;
        }
      }
    }

    .user-positive {
      @include flex(space-between);
      padding: 12px 10px 6px;

      .title {
        color: $color-gray-1;
        font-size: 14px;
        cursor: pointer;

        &:hover {
          color: $color-link;
        }
      }

      .switch {
        width: 44px;
        height: 26px;
      }
    }

    .split {
      position: relative;
      width: 200%;
      height: 1px;
      margin: 8px 0;
      transform: translateX(-10px);
      background: $color-split;
    }

    .title {
      @include flex(flex-start);
      height: 32px;
      padding: 6px 0;

      .btn-back {
        @include flex;
        width: 20px;
        height: 20px;
        margin-right: 10px;
        cursor: pointer;
      }
    }
  }
}
.icon-instagram,
.icon-line {
  width: 18px;
}

@media screen and (max-width: 599px) {
  header {
    padding: 0 14px 0 8px;

    .header-button {
      padding: 0 8px;

      &.openapp {
        @include button-yellow;
      }

      &.mobilelogin {
        padding: 0;
        margin-left: 12px;
      }
    }

    .logo {
      width: auto;
      height: 24px;

      img {
        height: 16px;
        margin-right: 4px;
      }
    }
  }
}

.user-status {
  position: absolute;
  @include flex(flex-start);
  bottom: 0;
  right: -2px;
  height: 13px;
  z-index: 10;
  color: $color-gray-2;
  font-size: 13px;
  padding: 0;

  &::before {
    content: '';
    width: 8px;
    height: 8px;
    border-radius: 100%;
    margin-right: 4px;
    background: $color-offline;
  }

  &.is-online::before {
    background: $color-green;
  }
}

.user-level-wrap {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.userlevel-tag {
  height: 18px;
  width: 40px;
  margin-right: 6px;
}

.user-level-text {
  font-size: 12px;
}

.user-level-arrow {
  margin-top: 1px;
  font-size: 12px;
  font-weight: 700;
  color: #8c94aa;
}
</style>

<style lang="scss">
.dialog-mobile-menu {
  overflow-x: hidden;
  height: 100vh;
  margin: 0 !important;
  border-radius: 0;

  .el-dialog__header {
    padding: 10px 16px;

    &btn {
      position: relative;
      top: auto;
      right: auto;

      i {
        font-size: 24px;
        color: $color-gray-1;
      }
    }
  }

  .el-dialog__body {
    padding: 0;

    nav {
      @include flex(flex-start);
      padding: 16px;
      color: $color-gray-1;
      font-size: 16px;

      &:active {
        background-color: #eee;
      }

      &:first-child {
        padding: 16px 8px;
      }

      > a {
        @include flex(flex-start);
        width: 100%;
        color: $color-gray-1;
      }

      i {
        margin-right: 12px;
      }
    }

    .line {
      width: 100%;
      height: 1px;
      background-color: $color-button;
      margin: 8px 0;
    }

    .dialog-login {
      font-weight: 600;
      font-size: 20px;
      line-height: 28px;
      margin-left: 10px;
      background-color: none;
    }

    .nav-userinfo {
      @include flex(flex-start);

      // 移动自适应的菜单头像
      .avatar-wrap {
        flex-shrink: 0;
        width: 40px;
        height: 40px;
        padding: 0;
      }

      .online-status {
        right: 0;
        bottom: 0;
      }

      .user-name {
        color: $color-gray-1;
        font-weight: 500;
        font-size: 16px;
        @include ellipsis;
      }
    }

    .dialog-download {
      padding: 0 16px;
      margin: 16px 0 64px;

      p {
        font-size: 16px;
        line-height: 22px;
      }

      img {
        display: block;
        width: auto;
        height: 45px;
        margin-top: 20px;
      }
    }
  }
}
</style>
